import { mdiAlertCircleOutline, mdiPause, mdiPlay } from "@mdi/js";
import { Tag } from "antd";
import { FailureStatusVm } from "api/generated/lumen";
import { MaterialIcon } from "components/MaterialIcon";
import React, { useMemo } from "react";

interface StatusTagProps {
  status: FailureStatusVm;
  useAlternativeName?: boolean;
}

const StatusTag: React.FC<StatusTagProps> = ({
  status,
  useAlternativeName,
}) => {
  const icon = useMemo(() => {
    if (status.isDefault) {
      return {
        tagColor: "error",
        tagIconPath: mdiAlertCircleOutline,
      };
    } else if (status.isSpecialCase) {
      return {
        tagColor: "warning",
        tagIconPath: mdiPause,
      };
    } else if (status.isSealed) {
      return {
        tagColor: "success",
        tagIconPath: mdiPlay,
      };
    }
  }, [status]);

  return (
    <Tag
      icon={icon ? <MaterialIcon path={icon.tagIconPath} /> : undefined}
      color={icon?.tagColor || undefined}
    >
      {useAlternativeName ? status.alternativeName : status.name}
    </Tag>
  );
};

export default StatusTag;
